var mentions_default = {
  "mentionPalette": "P7aVX",
  "mention": "U6wnC",
  "mentionViewer": "fkAWy",
  "mentionSuggestionsEntry": "NZcKW",
  "mentionSuggestionsEntryFocused": "VSmfk",
  "mentionSuggestionsEntryText": "-N-6A",
  "mentionSuggestionsEntryAvatar": "S9mmH",
  "mentionSuggestions": "T-kjx",
  "cursorDefault": "MLJJN",
  "cursorPointer": "G4AiB"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
